'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgCallBack(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M3 0H.667C.3 0 0 .3 0 .667 0 6.927 5.073 12 11.333 12c.367 0 .667-.3.667-.667V9.007c0-.367-.3-.667-.667-.667a7.605 7.605 0 01-2.38-.38.683.683 0 00-.68.16L6.807 9.587a10.1 10.1 0 01-4.394-4.394L3.88 3.727a.669.669 0 00.167-.68 7.574 7.574 0 01-.38-2.38C3.667.3 3.367 0 3 0z", id: "Call-back__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("path", { d: "M6.749 6h2.995a.751.751 0 00.749-.749.751.751 0 00-.749-.749h-1.19l3.227-3.227A.746.746 0 1010.725.219L7.498 3.446v-1.19a.751.751 0 00-.75-.749.751.751 0 00-.748.749V5.25c0 .412.337.749.749.749z", fill: "currentColor" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Call-back__svg__a" })))));
}

module.exports = SvgCallBack;
//# sourceMappingURL=CallBack.js.map
